import { Meta, MetaService } from './interfaces/Meta';

export class MetaServerService implements MetaService {
  public meta: Meta = { href: '' };

  public getMeta(): Meta {
    return this.meta;
  }
}
